import {
  Eraser, Frame, Hand, Highlighter, ImagePlus, Lasso, MousePointer2, NotebookText, PenLine, Shapes, Smile, Spline, StickyNote,
  Type, WandSparkles, type LucideIcon
} from "lucide-react";
import type { ToolId } from "../editor/editor";
import { useEditor, useUi } from "../editor/react/hooks";
import { IconButton, Panel } from "../ui/kit";

export const TOOL_INFO: Record<ToolId, { icon: LucideIcon; label: string; key: string }> = {
  select: { icon: MousePointer2, label: "Select", key: "V" },
  lasso: { icon: Lasso, label: "Lasso", key: "L" },
  hand: { icon: Hand, label: "Hand", key: "H" },
  pen: { icon: PenLine, label: "Pen", key: "P" },
  highlighter: { icon: Highlighter, label: "Highlighter", key: "M" },
  eraser: { icon: Eraser, label: "Eraser", key: "E" },
  shape: { icon: Shapes, label: "Shapes", key: "R" },
  line: { icon: Spline, label: "Arrow & connector", key: "A" },
  text: { icon: Type, label: "Text", key: "T" },
  note: { icon: StickyNote, label: "Sticky note", key: "N" },
  card: { icon: NotebookText, label: "Index card (markdown)", key: "C" },
  frame: { icon: Frame, label: "Page frame", key: "F" },
  sticker: { icon: Smile, label: "Stickers", key: "S" },
  laser: { icon: WandSparkles, label: "Laser pointer", key: "K" }
};

const GROUPS: ToolId[][] = [
  ["select", "lasso", "hand"],
  ["pen", "highlighter", "eraser"],
  ["shape", "line", "text", "note", "card"],
  ["sticker", "frame", "laser"]
];

export function Toolbar({ onImage, side }: { onImage: () => void; side: "left" | "right" }) {
  const ed = useEditor();
  const tool = useUi((ui) => ui.tool);
  const readOnly = useUi((ui) => ui.readOnly);
  const groups = readOnly ? [["select", "hand", "laser"] as ToolId[]] : GROUPS;
  const tip = side === "left" ? "right" : "left";
  return (
    <Panel className={"toolbar toolbar-" + side} seed="toolbar" tape="var(--rose)" tapeSide="center" aria-label="Tools" role="toolbar">
      {groups.map((g, gi) => (
        <div className="tool-group" key={gi}>
          {g.map((id) => {
            const info = TOOL_INFO[id];
            return (
              <IconButton
                key={id}
                icon={info.icon}
                label={info.label}
                shortcut={info.key}
                tipSide={tip}
                active={tool === id}
                onClick={() => ed.setTool(id)}
                className={"tool-" + id}
              />
            );
          })}
          {gi === 3 && !readOnly && <IconButton icon={ImagePlus} label="Image or photo" shortcut="I" tipSide={tip} onClick={onImage} />}
        </div>
      ))}
    </Panel>
  );
}
